import { ChakraProvider, extendTheme } from "@chakra-ui/react";
import theme from "@packages/theme/theme";
import router from "@router/router";
import GlobalStyles from "@styles/global";
import { RouterProvider } from "react-router-dom";
import { DesignMaxThemeProvider } from "./theme";
import { AnimateModalProvider, ModalProvider } from "./ui";

export const Providers = () => {
    const chakraTheme = extendTheme(theme);

    return (
        <ChakraProvider theme={chakraTheme}>
            <ModalProvider>
                <DesignMaxThemeProvider>
                    <AnimateModalProvider>
                        <GlobalStyles />
                        <RouterProvider router={router} />
                    </AnimateModalProvider>
                </DesignMaxThemeProvider>
            </ModalProvider>
        </ChakraProvider>
    );
};
